import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Link } from '../../../web/src/components/navigation/link.jsx';
import { USE_CASES } from '../use-cases/registry.jsx';
import { UseCaseIcon } from './use-case-icon.jsx';

/**
 * The use-case card grid. Renders from the USE_CASES registry, so it picks
 * up new use cases automatically. With `featured` it only shows the home
 * page's top use cases.
 * @param {{ featured?: boolean }} [props]
 * @returns {JSX.Element}
 */
export function UseCaseGrid({ featured } = {}) {
	const { lang } = useParams();
	const { t } = useTranslation();
	const cases = featured ? USE_CASES.filter((u) => u.featured) : USE_CASES;
	return (
		<div className="use-case-grid">
			{cases.map((u) => (
				<Link key={u.slug} to={`/${lang}/use-cases/${u.slug}/`} className="use-case-link card">
					<UseCaseIcon kind={u.icon} />
					<h3>{t(`usecase.${u.slug}.title`)}</h3>
					<p>{t(`usecase.${u.slug}.lede`)}</p>
				</Link>
			))}
		</div>
	);
}
